// The /go/ landing pages are otherwise zero-JS: static HTML, inline CSS and
// JSON-LD. This is the whole script they load — a page_view and the once-per-
// session recency signal, nothing else. It imports the SAME allow-listed client
// as the app, so there is exactly one place where an event name or a property
// key can be added, and the landing pages can never grow their own vocabulary.
//
// Which landing page a visit belongs to comes from the PATH (blob6), which the
// collector already records; the event itself carries only the page class. So
// there is no slug list to keep in sync with scripts/seo-pages.js.
import { trackPageView, trackVisitRecency } from './lib/analytics.js';

trackPageView('landing');
trackVisitRecency();
